import { render, staticRenderFns } from "./TheHundredYearsWarOnPalestineArticle.vue?vue&type=template&id=394b5b93&"
import script from "./TheHundredYearsWarOnPalestineArticle.vue?vue&type=script&lang=js&"
export * from "./TheHundredYearsWarOnPalestineArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports